import { Component, ReactNode } from 'react';
import { reportError } from '../../services/errorReportService';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };
  // Define a state variable to track whether is an error or not

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error) {
    // You can use your own error logging service here
    reportError(error);

    return { hasError: false };
  }

  public render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
